import Tasks from 'APP/Tasks';
import { ICalendarAuthAccount } from 'APP/model/calendar/calendar.types';
import Entities from 'STORE';

export const getAuthorizationAccounts = async (): Promise<ICalendarAuthAccount[]> => {
  try {
    const accounts = await Tasks.calendar.checkCalendarAuthorization();

    Entities.calendar.setAccounts(accounts || []);

    return accounts;
  } catch {
    return [];
  }
};
